import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Properties/Table";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
//import AddPropertyPage from "../../Components/AddPropertyTrash/AddPropertyPage";
import SummaryCards from "../../Components/Properties/SummaryCard";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { Form, Formik } from "formik";
import DeleteProperty from "../../Components/Properties/DeleteProperty";
import EditPropertyName from "../../Components/Properties/EditPropertyName";
import AddLocationModel from "../../Components/Properties/AddLocationModel";
import NotFoundModel from "../../Components/NotFoundModel";
import { AddBtn } from "../../Components/Styles/InputStyles";

const Properties = ({ }) => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [summaryData, setSummaryData] = useState();
  const [apiData, setApiData] = useState();
  const [isAddProperty, setIsAddProperty] = useState(false);
  const [isDeleteProperty, setIsDeleteProperty] = useState(false);
  const [editNameModel, setEditNameModel] = useState(false);
  const [locationModel, setLocationModel] = useState(false);
  const [step, setStep] = useState(1);
  const query = `&searchVal=&filter=${filter}`;

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/property/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    else {
      setApiData(res?.data);
      if (isFocused === false) {
        setSummaryData(res?.summary);
      }
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  useEffect(() => {
    if (filter) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 100);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter]);

  //------- Activate Property -------
  const ActivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/activate `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: activateLoading, mutate: activateMutate } = useMutation(
    ActivateFunction,
    {
      onSuccess: onActivateSuccess,
      onError: onActivateError,
    }
  );

  //------- Deactivate Property -------
  const DeactivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/deactivate  `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: DeactivateLoading, mutate: deactivateMutate } =
    useMutation(DeactivateFunction, {
      onSuccess: onDeactivateSuccess,
      onError: onDeactivateError,
    });

  const onSummaryBoxClick = (data) => {
    setFilter(data);
  };

  //------- Delete Property -------
  const deletePropertyFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/property/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deletePropertySuccess = (data) => {
    setIsDeleteProperty(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const deletePropertyError = (data) => {
    setIsDeleteProperty(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deletePropertyLoading, mutate: deletePropertyMutate } =
    useMutation(deletePropertyFunction, {
      onSuccess: deletePropertySuccess,
      onError: deletePropertyError,
    });

  //------- Edit Property Name -------
  const editNameFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/property/edit/name`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const editNameSuccess = (data) => {
    setEditNameModel(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const editNameError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editNameLoading, mutate: editNameMutate } = useMutation(
    editNameFunction,
    {
      onSuccess: editNameSuccess,
      onError: editNameError,
    }
  );

  //------- Add Latitude and Longitude -------
  const addLocationFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/update/longitude/latitude`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addLocationSuccess = (data) => {
    setLocationModel(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const addLocationError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLocationLoading, mutate: addLocationMutate } =
    useMutation(addLocationFunction, {
      onSuccess: addLocationSuccess,
      onError: addLocationError,
    });

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Properties
            <Underline />
          </BoxTitle>
          <Filters setIsAddProperty={setIsAddProperty} />
        </BoxHead>

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={5} />
        )}
        {isFocused && summaryData && (
          <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} />
        )}

        <div
          className={`${isAddProperty ? "flex" : "hidden"
            } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out z-10`}
        />
        {/* <div
          className={`${isAddProperty ? "translate-x-0" : "translate-x-full"
            } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-10`}
        >
          {isAddProperty && (
            <AddPropertyPage
              setIsAddProperty={setIsAddProperty}
              isAddProperty={isAddProperty}
              getListMutate={getListMutate}
              step={step}
              setStep={setStep}
              selectedData={selectedData}
              user={user}
            />
          )}
        </div> */}

        <div
          className={`${locationModel ? "flex" : "hidden"
            } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out z-10`}
        />
        <div
          className={`${locationModel ? "translate-x-0" : "translate-x-full"
            } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-10`}
        >
          {locationModel && (
            <AddLocationModel
              setLocationModel={setLocationModel}
              locationModel={locationModel}
              addLocationLoading={addLocationLoading}
              addLocationMutate={addLocationMutate}
              selectedData={selectedData}
            />
          )}
        </div>

        {isDeleteProperty && (
          <DeleteProperty
            setIsDeleteProperty={setIsDeleteProperty}
            isDeleteProperty={isDeleteProperty}
            deletePropertyLoading={deletePropertyLoading}
            deletePropertyMutate={deletePropertyMutate}
            selectedData={selectedData}
          />
        )}

        {editNameModel && (
          <EditPropertyName
            setEditNameModel={setEditNameModel}
            editNameLoading={editNameLoading}
            editNameMutate={editNameMutate}
            selectedData={selectedData}
          />
        )}

        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              step={step}
              setStep={setStep}
              setIsAddProperty={setIsAddProperty}
              isAddProperty={isAddProperty}
              activateLoading={activateLoading}
              activateMutate={activateMutate}
              deactivateMutate={deactivateMutate}
              DeactivateLoading={DeactivateLoading}
              setIsDeleteProperty={setIsDeleteProperty}
              setEditNameModel={setEditNameModel}
              setLocationModel={setLocationModel}
            />
            {/* {(error || data?.data?.msg === "No data found") && !isLoading && (
              <NotFoundModel />
            )} */}
          </TableWrapper>
        )}

        {(error || apiData.length === 0) && !isLoading && (
          <NotFoundModel />
        )}

        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ setIsAddProperty }) => {
  return (
    <Formik>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setIsAddProperty(true);
            }}
          >
            {"Add Property"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
const FilterContainer = tw.div`
    grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
export default Properties;
